<template>
	<c-dialog ref="dialog" mode="slide" width="1000" mask-close @resolve="submitHandle">
		<c-form ref="form" column="3" vertical unit-width="100%">
			<c-form link-parent>
				<c-form-item label="退货单号">
					<c-input name="return_code" :disabled="isEdit" placeholder="请输入，忽略将自动生成"></c-input>
				</c-form-item>
				<c-form-item label="退货给" required>
					<c-select name="to_saas_id" v-model="toSaasId" :options="merchantOptions" placeholder="请选择退货对象"></c-select>
				</c-form-item>
				<c-form-item label="快递单号">
					<c-input name="express_no" placeholder="请输入退货快递单号"></c-input>
				</c-form-item>
				<c-form-item label="备注" colspan="2">
					<c-input type="textarea" name="remark" maxlength="200" placeholder="请输入备注"></c-input>
				</c-form-item>
			</c-form>

			<c-title>退货商品明细</c-title>
			<c-form-item :label="false" name="product_list" colspan="3">
				<m-operate border>
					<c-input ref="codeInput" v-model="scanCode" placeholder="请扫描/输入本商户新背贴码" @keyup.enter.native="scanCodeHandle">
						<template #appendIcon><i class="tf-scan"></i></template>
					</c-input>
					<c-button color="main" @click="scanCodeHandle">确定</c-button>
					<c-button color="red" :hollow="true" prepend-icon="tf-trash" @click="batchRemove">批量移除</c-button>
				</m-operate>
				<c-table ref="productTable" :data="scannedList" border :paging="false">
					<template #empty>
						<c-empty message="请扫描退货商品背贴码"></c-empty>
					</template>
					<c-table-column type="selector" width="40"></c-table-column>
					<c-table-column label="产品信息" width="400">
						<template #default="{data}">
							<m-product-info :name="data.product_info || getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
						</template>
					</c-table-column>
					<!-- <c-table-column label="原背贴码" width="150">
						<template #default="{data}">{{data.source_produce_unique_code || '-'}}</template>
					</c-table-column> -->
					<c-table-column label="原调拨单号" width="150">
						<template #default="{data}">{{data.transfer_code || '-'}}</template>
					</c-table-column>
					<c-table-column label="成本价" width="80">
						<template #default="{data}"><span class="price-text">{{data.cost_price ? '¥' + data.cost_price : '-'}}</span></template>
					</c-table-column>
					<c-table-column label="接收时间" width="130">
						<template #default="{data}">{{data.receive_date || '-'}}</template>
					</c-table-column>
					<c-table-column label="操作" width="70" type="button">
						<template #default="{data}">
							<c-table-button color="red" icon="tf-trash" @click="removeItem(data)">移除</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	import scanCodeGuard from '@/mixins/scan_code_guard';

	export default {
		name: 'profitReturnEdit',
		mixins: [scanCodeGuard],

		data() {
			return {
				isEdit: false,
				returnId: '',
				toSaasId: '',
				merchantOptions: [],
				scanCode: '',
				scannedList: []
			}
		},

		methods: {
			/*********打开弹窗（data 存在为编辑）**********/
			open(data) {
				this.isEdit = !!(data && data.id);
				this.returnId = data ? data.id : '';
				this.toSaasId = '';
				this.scanCode = '';
				this.scannedList = [];
				this.$refs.form.clear();
				this.loadMerchants();
				this.$refs.dialog.open({title: this.isEdit ? '编辑分润退货' : '创建分润退货'});
				if (this.isEdit) {
					this.loadDetail(data.id);
				} else {
					this.focusInput();
				}
			},

			/*********加载退货对象下拉（基于历史「调拨给我」的已接收调拨单反向查对方商户）**********/
			loadMerchants() {
				this.request({
					url: '/profitTransferReturn/returnObjectList',
					data: {},
					success: list => {
						this.merchantOptions = (list || []).map(item => {
							return {name: item.merchant_name, value: item.merchant_saas_id};
						});
					}
				});
			},

			/*********编辑时加载退货单详情**********/
			loadDetail(id) {
				this.request({
					url: '/profitTransferReturn/detail',
					data: {id: id},
					loading: true,
					success: info => {
						this.$refs.form.set({
							return_code: info.return_code || '',
							to_saas_id: info.to_saas_id,
							express_no: info.express_no || '',
							remark: info.remark || ''
						});
						this.toSaasId = info.to_saas_id;
						this.scannedList = (info.product_list || []).map(item => {
							return {
								produce_unique_code_id: item.produce_unique_code_id,
								produce_unique_code: item.produce_unique_code,
								produce_imei: item.produce_imei,
								product_info: item.product_info,
								level_type: item.level_type,
								source_produce_unique_code: item.source_produce_unique_code,
								transfer_code: item.transfer_code,
								cost_price: item.cost_price,
								receive_date: item.receive_date
							};
						});
						this.focusInput();
					}
				});
			},

			/*********聚焦扫码输入框**********/
			focusInput() {
				this.$nextTick(() => {
					var input = this.$refs.codeInput && this.$refs.codeInput.$el.querySelector('input');
					if (input) input.focus();
				});
			},

			/*********扫码处理**********/
			scanCodeHandle() {
				var code = (this.scanCode || '').trim();
				if (!code) {
					this.$message({message: '请输入背贴码', type: 'warning'});
					return;
				}
				if (!this.toSaasId) {
					this.$message({message: '请先选择退货给商户', type: 'warning'});
					return;
				}
				if (this.scannedList.some(item => item.produce_unique_code == code)) {
					this.$message({message: '该背贴码已扫描', type: 'warning'});
					this.scanCode = '';
					this.focusInput();
					return;
				}
				//防止连续点击【确定】对同一背贴码并发请求，导致已扫列表重复录入
				if (this.isScanCodePending(code)) {
					this.$message({message: '该背贴码正在校验，请勿重复提交', type: 'warning'});
					return;
				}
				this.lockScanCode(code);
				this.request({
					url: '/profitTransferReturn/scan',
					data: {code: code, to_saas_id: this.toSaasId},
					success: row => {
						this.pushScannedItem(row, code);
						this.scanCode = '';
						this.focusInput();
					},
					fail: (code, data, msg) => {
						this.$message({message: msg || '扫描失败', type: 'error'});
						this.scanCode = '';
						this.focusInput();
						return false;
					},
					complete: () => {
						this.unlockScanCode(code);
					}
				});
			},

			/*********产品信息文字兜底**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.spu_model_name) parts.push(data.spu_model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join('/') || '-';
			},

			/*********移除已扫项**********/
			removeItem(data) {
				this.scannedList = this.scannedList.filter(item => item.produce_unique_code_id != data.produce_unique_code_id);
				this.focusInput();
			},

			/*********批量移除选中项**********/
			batchRemove() {
				let selectedList = this.$refs.productTable.getData('selected');
				if (!selectedList || selectedList.length == 0) {
					this.$message({message: '请先勾选要移除的记录', type: 'warning'});
					return;
				}
				var ids = selectedList.map(item => item.produce_unique_code_id);
				this.scannedList = this.scannedList.filter(item => !ids.includes(item.produce_unique_code_id));
				this.focusInput();
			},

			/*********提交**********/
			submitHandle(stop, next) {
				stop();
				var product_list = this.$refs.productTable.getData();
				if (!product_list || product_list.length == 0) {
					this.$message({message: '请至少添加一件退货商品', type: 'warning'});
					return;
				}
				this.$refs.form.submit({
					url: this.isEdit ? '/profitTransferReturn/update' : '/profitTransferReturn/create',
					rule: {
						to_saas_id: '请选择退货给商户'
					},
					dataFormatter: data => {
						if (this.isEdit) {
							data.id = this.returnId;
						}
						data.produce_unique_code_ids = product_list.map(item => item.produce_unique_code_id);
						return data;
					},
					success: (data, res, msg) => {
						next();
						this.$refs.dialog.close();
						this.$message({message: msg || (this.isEdit ? '编辑成功' : '创建成功'), type: 'success'});
						this.$emit('resolve');
					},
					fail: (data, code, res, msg) => {
						this.$message({message: msg, type: 'error'});
						return false;
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.price-text {
		color: #333;
		text-decoration: underline;
	}
</style>
